import { ImageProps } from 'next/image'
import * as React from 'react'

import { cn } from '@/lib/utils'

import { PageHeader, PageHeaderHeading } from '../common/page-header'
import { Shell } from '../common/shell'
import NextImage from '../NextImage'

interface RoadMapProps {
  className?: string
  roadmapHeading: React.ReactNode
  roadmapUrl: string
  children?: React.ReactNode
  imagesProps?: Partial<ImageProps>
}

function RoadMap({ className, roadmapHeading, roadmapUrl, children, imagesProps }: RoadMapProps) {
  return (
    <Shell className={cn('py-6 sm:py-10 md:py-12 lg:pt-16 lg:mt-10', className)}>
      <PageHeader className="w-full items-center justify-center flex mx-auto">
        <PageHeaderHeading className="text-center">{roadmapHeading}</PageHeaderHeading>
      </PageHeader>
      <div className="w-full mt-10">
        <NextImage
          src={roadmapUrl}
          alt="Hero image"
          className="mx-auto max-w-[1216px] w-full rounded-3xl flex justify-center items-center"
          classNames={{
            image: 'select-none',
          }}
          width={900}
          height={800}
          quality={100}
          sizes="(max-width: 640px) 100vw, (max-width: 768px) 90vw, (max-width: 1024px) 80vw, 1216px"
          {...imagesProps}
        />
      </div>
      {children}
    </Shell>
  )
}

export default RoadMap
